import { Outlet, useNavigate } from "react-router-dom";
import classes from "./index.module.css";
import { Typography } from "@mui/material";
import { pxToRem } from "../../theme/typography";
import Purple_sdd from "./../../assets/Svg/Purple_sdd.svg"
import { imageURLRender } from "../../utils";
const Socialicons = [
    // facebook
    <div style={{
        width: '32px',
        height: '32px',
        fill: '#1877F2',
    }}>
        <a href="https://www.facebook.com/Scientific-Self-Discovery-113079938467490" target="_blank" rel="noreferrer">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="16" fill="#1877F2" />
                <path d="M22.2281 20.625L22.9375 16H18.5V13C18.5 11.7344 19.1188 10.5 21.1063 10.5H23.125V6.5625C23.125 6.5625 21.2938 6.25 19.5438 6.25C15.8875 6.25 13.5 8.46563 13.5 12.475V16H9.4375V20.625H13.5V31.8062C14.3156 31.9344 15.15 32 16 32C16.85 32 17.6844 31.9344 18.5 31.8062V20.625H22.2281Z" fill="white" />
            </svg> */}
            <img src={imageURLRender('/public/profile/photo-1687798717766.png')} alt="facebook" style={{
                height: '32px',
                width: '32px',
            }}/>
        </a>

    </div>,
    // discord
    <div style={{
        width: '32px',
        height: '32px',
        fill: '#1D9BF0',
    }}>
        <a href="https://discord.com/invite/YZ9Aq7EYMB" target="_blank" rel="noreferrer">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="16" fill="#1D9BF0" />
                <path d="M13.0718 24.4402C20.1678 24.4402 24.0478 18.5602 24.0478 13.4642C24.0478 13.2962 24.0478 13.1282 24.0398 12.9682C24.7918 12.4242 25.4478 11.7442 25.9678 10.9682C25.2798 11.2722 24.5358 11.4802 23.7518 11.5762C24.5518 11.0962 25.1598 10.3442 25.4478 9.44016C24.7038 9.88016 23.8798 10.2002 22.9998 10.3762C22.2958 9.62416 21.2958 9.16016 20.1838 9.16016C18.0558 9.16016 16.3278 10.8882 16.3278 13.0162C16.3278 13.3202 16.3598 13.6162 16.4318 13.8962C13.2238 13.7362 10.3838 12.2002 8.47978 9.86416C8.15178 10.4322 7.95978 11.0962 7.95978 11.8002C7.95978 13.1362 8.63978 14.3202 9.67978 15.0082C9.04778 14.9922 8.45578 14.8162 7.93578 14.5282C7.93578 14.5442 7.93578 14.5602 7.93578 14.5762C7.93578 16.4482 9.26378 18.0002 11.0318 18.3602C10.7118 18.4482 10.3678 18.4962 10.0158 18.4962C9.76778 18.4962 9.52778 18.4722 9.28778 18.4242C9.77578 19.9602 11.1998 21.0722 12.8878 21.1042C11.5678 22.1362 9.90378 22.7522 8.09578 22.7522C7.78378 22.7522 7.47978 22.7362 7.17578 22.6962C8.86378 23.8002 10.8958 24.4402 13.0718 24.4402Z" fill="white" />
            </svg> */}
            <img src={imageURLRender('/public/profile/photo-1687798817546.png')} alt="discord" style={{
                height: '32px',
                width: '32px',
            }}/>
        </a>

    </div>,
    // instagram
    <div style={{
        width: '32px',
        height: '32px',
        fill: '#F9F9F9',
    }}>
        <a href="https://www.instagram.com/scientific.self.discovery" target="_blank" rel="noreferrer">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="16" fill="#F9F9F9" />
                <path d="M16.0036 8.13083C18.5688 8.13083 18.8699 8.14226 19.8838 8.188C20.8214 8.22993 21.3283 8.3862 21.6676 8.51961C22.1173 8.69494 22.4375 8.90076 22.7729 9.23618C23.1083 9.57159 23.318 9.89176 23.4895 10.3415C23.6191 10.6808 23.7792 11.1877 23.8211 12.1253C23.8668 13.1392 23.8783 13.4403 23.8783 16.0055C23.8783 18.5706 23.8668 18.8717 23.8211 19.8856C23.7792 20.8233 23.6229 21.3302 23.4895 21.6694C23.3142 22.1192 23.1083 22.4394 22.7729 22.7748C22.4375 23.1102 22.1173 23.3198 21.6676 23.4913C21.3283 23.6209 20.8214 23.781 19.8838 23.8229C18.8699 23.8687 18.5688 23.8801 16.0036 23.8801C13.4385 23.8801 13.1373 23.8687 12.1235 23.8229C11.1858 23.781 10.6789 23.6247 10.3397 23.4913C9.88991 23.316 9.56974 23.1102 9.23432 22.7748C8.8989 22.4394 8.68927 22.1192 8.51775 21.6694C8.38816 21.3302 8.22807 20.8233 8.18615 19.8856C8.14041 18.8717 8.12897 18.5706 8.12897 16.0055C8.12897 13.4403 8.14041 13.1392 8.18615 12.1253C8.22807 11.1877 8.38435 10.6808 8.51775 10.3415C8.69308 9.89176 8.8989 9.57159 9.23432 9.23618C9.56974 8.90076 9.88991 8.69113 10.3397 8.51961C10.6789 8.39001 11.1858 8.22993 12.1235 8.188C13.1373 8.13845 13.4423 8.13083 16.0036 8.13083ZM16.0036 6.40039C13.3965 6.40039 13.0687 6.41183 12.0434 6.45756C11.0219 6.5033 10.3244 6.6672 9.71457 6.90351C9.08186 7.14745 8.54824 7.47906 8.01463 8.01267C7.48101 8.54629 7.15322 9.08371 6.90547 9.71262C6.66915 10.3225 6.50526 11.02 6.45952 12.0453C6.41378 13.0668 6.40234 13.3946 6.40234 16.0017C6.40234 18.6088 6.41378 18.9365 6.45952 19.9619C6.50526 20.9833 6.66915 21.6809 6.90547 22.2945C7.14941 22.9272 7.48101 23.4608 8.01463 23.9945C8.54824 24.5281 9.08567 24.8559 9.71457 25.1036C10.3244 25.3399 11.0219 25.5038 12.0472 25.5496C13.0725 25.5953 13.3965 25.6067 16.0074 25.6067C18.6183 25.6067 18.9423 25.5953 19.9676 25.5496C20.9891 25.5038 21.6866 25.3399 22.3003 25.1036C22.933 24.8597 23.4666 24.5281 24.0002 23.9945C24.5339 23.4608 24.8616 22.9234 25.1094 22.2945C25.3457 21.6847 25.5096 20.9872 25.5553 19.9619C25.6011 18.9365 25.6125 18.6126 25.6125 16.0017C25.6125 13.3908 25.6011 13.0668 25.5553 12.0415C25.5096 11.02 25.3457 10.3225 25.1094 9.70881C24.8655 9.07609 24.5339 8.54248 24.0002 8.00886C23.4666 7.47524 22.9292 7.14745 22.3003 6.8997C21.6904 6.66339 20.9929 6.49949 19.9676 6.45375C18.9385 6.41183 18.6107 6.40039 16.0036 6.40039Z" fill="#190D1A" />
                <path d="M16.0024 11.0723C13.281 11.0723 11.0703 13.2791 11.0703 16.0044C11.0703 18.7296 13.2772 20.9365 16.0024 20.9365C18.7277 20.9365 20.9346 18.7296 20.9346 16.0044C20.9346 13.2791 18.7277 11.0723 16.0024 11.0723ZM16.0024 19.2023C14.2339 19.2023 12.8008 17.7691 12.8008 16.0006C12.8008 14.232 14.2339 12.7989 16.0024 12.7989C17.771 12.7989 19.2041 14.232 19.2041 16.0006C19.2041 17.7691 17.771 19.2023 16.0024 19.2023Z" fill="#190D1A" />
                <path d="M21.1276 12.0268C21.7634 12.0268 22.2787 11.5114 22.2787 10.8757C22.2787 10.24 21.7634 9.72461 21.1276 9.72461C20.4919 9.72461 19.9766 10.24 19.9766 10.8757C19.9766 11.5114 20.4919 12.0268 21.1276 12.0268Z" fill="#190D1A" />
            </svg> */}
             <img src={imageURLRender('/public/profile/photo-1687798768393.png')} alt="instagram" style={{
                height: '32px',
                width: '32px',
            }}/>
        </a>

    </div>,
    // linkdin
    <div style={{
        width: '32px',
        height: '32px',
        fill: '#0A66C2',
    }}>
        <a href="https://www.linkedin.com/company/scientific-self-discovery" target="_blank" rel="noreferrer">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="16" fill="#0A66C2" />
                <path d="M23.5 7.19922H8.49844C8.15387 7.19922 7.8234 7.3361 7.57975 7.57975C7.3361 7.8234 7.19922 8.15387 7.19922 8.49844V23.5C7.19922 23.8446 7.3361 24.175 7.57975 24.4187C7.8234 24.6623 8.15387 24.7992 8.49844 24.7992H23.5C23.8446 24.7992 24.175 24.6623 24.4187 24.4187C24.6623 24.175 24.7992 23.8446 24.7992 23.5V8.49844C24.7992 8.15387 24.6623 7.8234 24.4187 7.57975C24.175 7.3361 23.8446 7.19922 23.5 7.19922ZM12.445 22.1922H9.79889V13.787H12.445V22.1922ZM11.1201 12.6222C10.82 12.6205 10.527 12.53 10.2783 12.3619C10.0296 12.1939 9.83617 11.956 9.72253 11.6782C9.60889 11.4004 9.58009 11.0951 9.63977 10.801C9.69946 10.5068 9.84494 10.2369 10.0579 10.0253C10.2708 9.81376 10.5416 9.67001 10.8362 9.61222C11.1307 9.55443 11.4358 9.58519 11.7129 9.70061C11.9899 9.81603 12.2266 10.0109 12.393 10.2607C12.5594 10.5106 12.6481 10.8041 12.6479 11.1042C12.6507 11.3052 12.6131 11.5046 12.5372 11.6907C12.4613 11.8768 12.3487 12.0457 12.2061 12.1874C12.0635 12.3291 11.8939 12.4406 11.7073 12.5153C11.5208 12.59 11.321 12.6263 11.1201 12.6222ZM22.1983 22.1996H19.5534V17.6077C19.5534 16.2534 18.9778 15.8354 18.2347 15.8354C17.45 15.8354 16.68 16.427 16.68 17.6419V22.1996H14.0339V13.7931H16.5786V14.9579H16.6128C16.8682 14.4409 17.7629 13.5572 19.1281 13.5572C20.6046 13.5572 22.1996 14.4336 22.1996 17.0002L22.1983 22.1996Z" fill="white" />
            </svg> */}
             <img src={imageURLRender('/public/profile/photo-1687798863414.png')} alt="linkdIn" style={{
                height: '32px',
                width: '32px',
            }}/>
        </a>

    </div>,
]
const WebsiteView = () => {
    const navigate = useNavigate()
    return (
        <div className={window.florishApp ? classes.conatinerFlourishMain : classes.conatinerMain}>
            <div className={classes.containerMenu}>
                <div className={classes.containerLogo}>
                    <div className={window.florishApp ? classes.containerLogoFlourishName : classes.containerLogoName}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: `${pxToRem(window.florishApp ? 25 : 14)} !important`,
                                color: window.florishApp ? "#070D23" : "#FFF"
                            }}>{window.florishApp ? "FlourishLabs" : "Scientific Self-Discovery"}</Typography>
                    </div>
                    {!window.florishApp && (
                        <div className={classes.containerLogoIcon}>
                            <div className={classes.containerLogoIcon1}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: `${pxToRem(14)} !important`,
                                        color: "#9747FF"
                                    }}>β</Typography>
                            </div>
                        </div>
                    )}

                </div>
                {/* <div className={classes.centerMenu}>
                    <div className={classes.loginButton}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: "#190D1A"
                            }}>Features</Typography>
                    </div>
                    <div className={classes.loginButton}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: "#190D1A"
                            }}>Pricing</Typography>
                    </div>
                    <div className={classes.loginButton}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: "#190D1A"
                            }}>Blog</Typography>
                    </div>
                    <div className={classes.loginButton}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: "#190D1A"
                            }}>FAQ</Typography>
                    </div>
                </div> */}
                <div className={classes.loginInfo}>
                    <div className={window.florishApp ? classes.loginFlourishButton : classes.loginButton} onClick={() => navigate('/')}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: `${pxToRem(14)} !important`,
                                color: window.florishApp ? "#000" : "#190D1A",
                            }}
                        >Log in</Typography>
                    </div>
                    <div className={window.florishApp ? classes.joinFlourishButton : classes.joinButton} onClick={() => navigate('/signup')}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: `${pxToRem(14)} !important`,
                                color: "#FFF"
                            }}>{window.florishApp ? "Sign Up" : "Join waitlist"}</Typography>
                    </div>
                </div>
            </div>
            <div className={classes.contentLayout}>
                <div className={classes.shareViewConteiner}>
                    <div className={classes.background}>
                        {/* <div className={classes.ellipse511}></div>
                        <div className={classes.ellipse515}></div>
                        <div className={classes.ellipse510}></div>
                        <div className={classes.ellipse516}></div>
                        <div className={classes.ellipse517}></div>
                        <div className={classes.ellipse514}></div> */}
                    </div>

                    <div className={classes.frame3751}>
                        <div className={classes.frame3747}>
                            <img src={Purple_sdd} alt="Purple_sdd" style={{
                                width: '50px',
                                height: '69px',

                            }} />
                            <Typography
                                sx={{
                                    fontWeight: 500,
                                    fontSize: `${pxToRem(18)} !important`,
                                    color: window.florishApp ? "#000" : "#9747FF"
                                }}>{window.florishApp ? "FlourishLabs" : "Scientific Self-Discovery"}</Typography>
                            <Outlet />
                        </div>
                        <div className={classes.frame3750}>
                            <div className={classes.frame3749}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: `${pxToRem(18)} !important`,
                                        color: "#190D1A"
                                    }}>{window.florishApp ? "FlourishLabs" : "Scientific Self-Discovery"} in media</Typography>
                                <div className={classes.frame3748}>
                                    {Socialicons.map(it => it)}
                                </div>
                            </div>
                            <div className={classes.frame3745}>
                                <div className={classes.rectangle}></div>

                            </div>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(12)} !important`,
                                    color: "#767476",
                                    textAlign: "center",
                                    alignSelf: "center",
                                    width: "60%"
                                }}>Please, do not reply to this email — it’s sent by a robot. You received this email, because your friend sent you an invite.</Typography>
                        </div>
                    </div>


                </div>
                <div className={window.florishApp ? classes.bottomFlourishLayout : classes.bottomLayout}>
                    <div className={classes.frame4451}>
                        <div className={window.florishApp ? "" : classes.frame21}>
                            <div className={window.florishApp ? "" : classes.containerLogoName}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: `${pxToRem(14)} !important`,
                                        color: "#FFF"
                                    }}>{window.florishApp ? "FlourishLabs" : "Scientific Self-Discovery"}</Typography>
                            </div>
                            {!window.florishApp && <div className={classes.containerLogoIcon}>
                                <div className={classes.containerLogoIcon1}>
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: `${pxToRem(14)} !important`,
                                            color: "#9747FF"
                                        }}>β</Typography>
                                </div>
                            </div>}
                        </div>
                        <div className={classes.frame4448}>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}>About</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"
                                }}
                                onClick={() => window.open(`https://scientific-selfdiscovery.com/#features`, '_blank')}>Features</Typography>
                            {/* <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: "#190D1A"
                                }}>Pricing</Typography> */}
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}
                                onClick={() => window.open(`https://scientific-selfdiscovery.com/faq`, '_blank')}
                            >FAQ</Typography>
                        </div>
                        <div className={classes.frame4448}>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}>Support</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}
                                onClick={() => window.open(`https://scientific-selfdiscovery.com/help-centre`, '_blank')}
                            >Help Centre</Typography>
                            {/* <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: "#190D1A"
                                    ,cursor: "pointer"

                                }}>Call Centre</Typography> */}

                        </div>
                        <div className={classes.frame4448}>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                }}
                            >Social</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}
                                onClick={() => window.open(`https://www.linkedin.com/company/scientific-self-discovery/`, '_blank')}>Linkedin</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }}
                                onClick={() => window.open(`https://www.instagram.com/scientific.self.discovery/`, '_blank')}>Instagram</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }} onClick={() => window.open(`https://discord.com/invite/YZ9Aq7EYMB`, '_blank')}>Discord</Typography>
                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: `${pxToRem(14)} !important`,
                                    color: window.florishApp ? "#FFF" : "#190D1A"
                                    , cursor: "pointer"

                                }} onClick={() => window.open(`https://www.facebook.com/Scientific-Self-Discovery-113079938467490/`, '_blank')}>Facebook</Typography>

                        </div>
                        <div className={classes.loginInfo}>
                            <div className={classes.loginButton} onClick={() => navigate('/signup')}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: `${pxToRem(14)} !important`,
                                        color: window.florishApp ? "#FFF" : "#190D1A"
                                    }}>{window.florishApp ? "Sign Up" : "Join waitlist"}</Typography>
                            </div>
                            <div className={window.florishApp ? classes.bottomLoginButton : classes.joinButton} style={{ cursor: "pointer" }} onClick={() => navigate('/')}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: `${pxToRem(14)} !important`,
                                        color: "#FFF",

                                    }}
                                >Log in</Typography>
                            </div>
                        </div>
                    </div>
                    <div className={classes.frame4447}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: window.florishApp ? "#FFF" : "#190D1A"
                            }}>With 💚 from Flourishing Humanity Co.</Typography>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: window.florishApp ? "#FFF" : "#190D1A",
                                opacity: "0.5",
                                cursor: "pointer"
                            }}
                            onClick={() => window.open(`https://scientific-selfdiscovery.com/privacy-policy/`, '_blank')}>Privacy Policy</Typography>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: window.florishApp ? "#FFF" : "#190D1A",
                                opacity: "0.5",
                                cursor: "pointer"
                            }} onClick={() => window.open(`https://scientific-selfdiscovery.com/cookiepolicy`, '_blank')}>Cookie Policy</Typography>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: `${pxToRem(14)} !important`,
                                color: window.florishApp ? "#FFF" : "#190D1A",
                            }}></Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebsiteView